import React, {Component} from 'react';
import { deleteArticle, reset, } from "../redux/actions/register/articles";
import '../assets/css/dashboard.css';
import {connect} from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
class DeleteArticle extends Component {
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.msg_deleteArticle && prevProps.msg_deleteArticle !== this.props.msg_deleteArticle) {
            toast(this.props.msg_deleteArticle);
            const {
                reset
            } = this.props;
            clearTimeout(this.tmr);
            this.tmr = setTimeout(function () {
                reset();
                this.tmr = null;
                window.location.href = '/published';
            }, 2000);
        }
    }

    Cancel = () => {
        const {
            handleClose
        } = this.props;

        handleClose();
    };
    deleteToggle = (_id) => {
        const data = {
            auth_id: localStorage.client_id,
            _id: _id,
        };
        const {
            deleteArticle
        } = this.props;
        deleteArticle(data);
    };
    render() {
        const showHideClassName = this.props.show ? "modal-b display-modal-block" : "modal-b display-modal-none";
        return (
            <div className={showHideClassName}>
                <ToastContainer />
                <div className={"spinning-curtain"} style={{display: this.props.spinning ? "flex" : "none"}}>
                    <div className="lds-dual-ring"/>
                </div>
                <section className="modal-article">
                    <div className="create-modal-header txt-18 justify-left col-white">Delete Article</div>
                    <div className="pt-45 pb-30 txt-16 col-blue justify-center">Do you want to delete this article really?</div>
                    <div className="flex-grid2 modal-grid2-gaps modal-p">
                        <div className="btn-common cancel mouse-cursor justify-center" onClick={this.Cancel}>Cancel</div>
                        <div className="btn-common create btn-delete mouse-cursor justify-center col-white" onClick={() => this.deleteToggle(this.props.deleteId)}>Delete</div>
                    </div>
                </section>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        spinning: state.registers.spinning,
        msg_deleteArticle: state.registers.msg_deleteArticle,
    }
};
export default connect(
    mapStateToProps,
    {
        reset,
        deleteArticle,
    }
)(DeleteArticle);

